import { render, staticRenderFns } from "./outpatient.vue?vue&type=template&id=6a9ce85e&scoped=true"
import script from "./outpatient.vue?vue&type=script&lang=js"
export * from "./outpatient.vue?vue&type=script&lang=js"
import style0 from "./outpatient.vue?vue&type=style&index=0&id=6a9ce85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ce85e",
  null
  
)

export default component.exports